const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.25,15.75C4.5,-3,31.5,-3,34.5,15.75C31.5,-3,4.5,-3,2.25,15.75M34.5,21.75C31.5,39.75,4.5,39.75,2.25,21.75C4.5,39.75,31.5,39.75,34.5,21.75M1.5,17.25C1.5,17.25,0.75,11.25,0.75,11.25C0.75,11.25,5.25,12.75,5.25,12.75C5.25,12.75,1.5,17.25,1.5,17.25M18.375,13.5C14.33365121715164,13.528867779675956,11.83905817023386,17.92179853381868,13.884732792208268,21.407275355480703C15.930407414182675,24.89275217714273,20.982093392743124,24.856667452547782,22.977767553617074,21.342322851209808C24.957015181363438,17.856905065254544,22.458084159312556,13.5286301669692,18.450000000000003,13.5M34.5,21.75C34.5,21.75,35.25,27.75,35.25,27.75C35.25,27.75,30,26.25,30,26.25C30,26.25,34.5,21.75,34.5,21.75",
    id: "dpo8-id-15-rotation",
    fill: "#000000",
    stroke: "#000000",
    style: {
      strokeWidth: 2
    },
    className: "",
    fillOpacity: 1,
    strokeOpacity: 1
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.8668e5921ec1f99c1daf773cbd5e0a29.svg";
export { ForwardRef as ReactComponent };